@if (taskAnimationComplete()) {
  <div class="trial-counter-container">
    <div class="trial-counter-background" [style.background]="' ' + trialCounterColor + ' '">
      <div class="trial-counter-left-margin-space"></div>
      @for (trial of trialStatus; track trial) {
        <wf-trial-counter-chip [trialStatus]="trial"></wf-trial-counter-chip>
      }
    </div>
    <div class="trial-counter-avatar" [style.background-image]="'url(' + avatarIcon + ')'"></div>
  </div>
}
